// extracted by mini-css-extract-plugin
module.exports = {"option-wrapper":"graphql-select-options__option-wrapper___2l1xD","option-label":"graphql-select-options__option-label___3zWC6"};